import React, { forwardRef } from 'react';
import {
	PrimaryDropdownButton as FullPrimaryDropdownButton,
	type PrimaryDropdownButtonProps,
} from '@atlaskit/atlassian-navigation';
import { SkeletonPrimaryButton } from '@atlaskit/atlassian-navigation/skeleton';

export const PrimaryDropdownButton = forwardRef<HTMLElement, PrimaryDropdownButtonProps>(
	(props, ref) => {
		if (__SERVER__) {
			return (
				<SkeletonPrimaryButton
					isDropdownButton
					isHighlighted={props.isHighlighted}
					text={props.children === undefined ? '' : props.children}
				/>
			);
		}

		const buttonProps = {
			...props,
			ref,
		};

		return <FullPrimaryDropdownButton {...buttonProps} />;
	},
);
